import {Box, HBox} from '@buncha/components/core/view';
import {Divider, Skeleton} from 'native-base';
import React, {useCallback} from 'react';

import If from '@buncha/components/conditional/If';
import Scrollview from '@buncha/components/composites/scrollview';
import StepSkeleton from '../stepSkeleton/StepSkeleton';
import {scaleFonts} from '@buncha/appStyles/style/font';
import {styles} from './styles';

const OrderInfoSkeleton: React.FC = () => {
  const stepData = Array(4).fill(0);
  const renderStepSkeleton = useCallback(
    (index: number) => {
      return (
        <StepSkeleton key={index} index={index} totalSteps={stepData.length} />
      );
    },
    [stepData.length],
  );

  const bottomSkeleton = useCallback((showRight?: boolean) => {
    return (
      <HBox>
        <Box style={styles.bottomLeftBox}>
          <Skeleton style={styles.bottomSkeletonLine1} />
          <Skeleton style={styles.bottomSkeletonLine2} />
          <Skeleton style={styles.bottomSkeletonLine3} />
        </Box>
        <Box style={styles.bottomRightBox}>
          <If condition={showRight}>
            <Skeleton
              width={'40%'}
              height={scaleFonts(5)}
              borderRadius={5}
              startColor="green.500"
            />
          </If>
        </Box>
      </HBox>
    );
  }, []);

  return (
    <Box style={styles.flex1}>
      <Skeleton style={{height: scaleFonts(100)}} />
      <Scrollview>
        <Box style={styles.mainContainer}>
          <Box style={styles.headerSection}>
            <Skeleton width={'40%'} height={scaleFonts(5)} borderRadius={5} />
            <Skeleton width={'70%'} height={scaleFonts(5)} borderRadius={5} />
          </Box>
          {stepData.map((_, index) => {
            return renderStepSkeleton(index);
          })}
          <Divider style={styles.divider} />
          {bottomSkeleton(true)}
          <Divider style={styles.divider} />
          {bottomSkeleton()}
        </Box>
      </Scrollview>
    </Box>
  );
};

export default React.memo(OrderInfoSkeleton);
